module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    attrs: {
      "modal-size": 'large',
      "modal-title": 'Edit Component'
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      },
      "save": function($event) {
        return _vm.saveComponent()
      }
    }
  }, [_c('div', {
    staticClass: "split"
  }, [_c('div', {
    staticClass: "half"
  }, [_c('h3', [_vm._v("Edit")]), _vm._v(" "), _c('form', {
    staticClass: "component-form"
  }, [_c('div', {
    staticClass: "panel panel-primary"
  }, [_c('div', {
    staticClass: "panel-header",
    attrs: {
      "role": "tab"
    }
  }, [_c('h3', [_vm._v("General")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    staticClass: "form-inline"
  }, [_c('FormulateInput', {
    attrs: {
      "type": "text",
      "label": "Title",
      "required": ""
    },
    model: {
      value: (_vm.componentModel.name),
      callback: function($$v) {
        _vm.$set(_vm.componentModel, "name", $$v)
      },
      expression: "componentModel.name"
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "select",
      "label": "Visualization Type",
      "options": _vm.chartChoices
    },
    on: {
      "input": _vm.fetchVizAxis
    },
    model: {
      value: (_vm.componentModel.chart),
      callback: function($$v) {
        _vm.$set(_vm.componentModel, "chart", $$v)
      },
      expression: "componentModel.chart"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Filter Rule")]), _vm._v(" "), _c('boolean-expression-widget', {
    attrs: {
      "expression": _vm.componentModel.filter_rule
    },
    on: {
      "updateExpression": _vm.updateFilterRule
    }
  }), _vm._v(" "), (_vm.xAxisName) ? _c('div', [_c('h4', [_vm._v(_vm._s(_vm.xAxisName) + " "), (!_vm.xAxisRequired) ? _c('small', [_vm._v("(optional)")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.componentModel.domains), function(domain) {
    return _c('div', {
      staticClass: "domain-item"
    }, [_c('FormulateInput', {
      attrs: {
        "type": "text",
        "label": "Label"
      },
      model: {
        value: (domain.name),
        callback: function($$v) {
          _vm.$set(domain, "name", $$v)
        },
        expression: "domain.name"
      }
    }), _vm._v(" "), _c('FormulateInput', {
      attrs: {
        "type": "select",
        "options": _vm.domainFieldOptions,
        "label": "Field"
      },
      model: {
        value: (domain.field),
        callback: function($$v) {
          _vm.$set(domain, "field", $$v)
        },
        expression: "domain.field"
      }
    }), _vm._v(" "), _c('FormulateInput', {
      attrs: {
        "type": "button",
        "label": "Reset"
      },
      on: {
        "click": function($event) {
          return _vm.resetDomain()
        }
      }
    })], 1)
  })], 2) : _vm._e()], 1)])]), _vm._v(" "), (_vm.yAxisName) ? _c('div', {
    staticClass: "panel panel-primary series"
  }, [_c('div', {
    staticClass: "panel-header clearfix"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.yAxisName))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('draggable', {
    attrs: {
      "list": _vm.componentModel.images
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "list-complete"
    }
  }, _vm._l((_vm.componentModel.images), function(image, imageIndex) {
    return _c('div', {
      key: _vm.itemKey(image),
      staticClass: "list-complete-item"
    }, [_c('form', {
      staticClass: "form-inline"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (image.order),
        expression: "image.order"
      }],
      attrs: {
        "type": "hidden"
      },
      domProps: {
        "value": (image.order)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(image, "order", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (image.name),
        expression: "image.name",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": "image-name",
        "placeholder": "Image name",
        "required": ""
      },
      domProps: {
        "value": (image.name)
      },
      on: {
        "change": function($event) {
          return _vm.renderPreview()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(image, "name", $event.target.value.trim())
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (image.kind),
        expression: "image.kind"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(image, "kind", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.renderPreview()
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "null",
        "disabled": "",
        "hidden": ""
      }
    }, [_vm._v("Select Kind")]), _vm._v(" "), _vm._l((_vm.ImageKindChoices), function(choice) {
      return _c('option', {
        domProps: {
          "value": choice.id
        }
      }, [_vm._v(_vm._s(choice.text))])
    })], 2)]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-link pull-right",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeImage(imageIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "table-responsive",
      staticStyle: {
        "display": "initial"
      }
    }, [_c('table', {
      staticClass: "table table-yaxis"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Serie name")]), _vm._v(" "), _c('th', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (image.kind == 'score'),
        expression: "image.kind == 'score'"
      }]
    }, [_vm._v("Scoring model")]), _vm._v(" "), _c('th', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (image.kind == 'value'),
        expression: "image.kind == 'value'"
      }]
    }, [_vm._v("Field")]), _vm._v(" "), _c('th', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (image.kind != 'count'),
        expression: "image.kind != 'count'"
      }]
    }, [_vm._v("Aggregations")]), _vm._v(" "), _c('th', {
      attrs: {
        "width": "38px"
      }
    }, [_c('button', {
      staticClass: "btn btn-default btn-xs pull-right",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addSerieToImage(imageIndex)
        }
      }
    }, [_vm._v("\n                                                            Add serie\n                                                        ")])])])]), _vm._v(" "), _vm._l((image.series), function(obj, index) {
      return _c('tbody', {
        key: _vm.itemKey(obj)
      }, [_c('tr'), _c('tr', [_c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (obj.order),
          expression: "obj.order"
        }],
        attrs: {
          "type": "hidden"
        },
        domProps: {
          "value": (obj.order)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(obj, "order", $event.target.value)
          }
        }
      }), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model.trim",
          value: (obj.name),
          expression: "obj.name",
          modifiers: {
            "trim": true
          }
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "placeholder": "name",
          "required": ""
        },
        domProps: {
          "value": (obj.name)
        },
        on: {
          "change": function($event) {
            return _vm.renderPreview()
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(obj, "name", $event.target.value.trim())
          },
          "blur": function($event) {
            return _vm.$forceUpdate()
          }
        }
      })]), _vm._v(" "), _c('td', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (image.kind == 'score'),
          expression: "image.kind == 'score'"
        }],
        class: {
          'has-error': !obj.scoring_model && _vm.hasSumit && obj.aggregation !== undefined && obj.aggregation != 0
        }
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (obj.scoring_model),
          expression: "obj.scoring_model"
        }],
        staticClass: "form-control",
        attrs: {
          "disabled": image.kind != 'score'
        },
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(obj, "scoring_model", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }, function($event) {
            return _vm.renderPreview()
          }]
        }
      }, [_c('option', {
        attrs: {
          "value": "",
          "disabled": "",
          "hidden": ""
        }
      }, [_vm._v("Select Scoring")]), _vm._v(" "), _vm._l((_vm.ScoringModelChoices), function(choice) {
        return _c('option', {
          domProps: {
            "value": choice.id
          }
        }, [_vm._v(_vm._s(choice.text))])
      })], 2)]), _vm._v(" "), _c('td', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (image.kind == 'value'),
          expression: "image.kind == 'value'"
        }]
      }, [_c('FormulateInput', {
        attrs: {
          "type": "select",
          "options": _vm.serieFieldOptions
        },
        model: {
          value: (obj.field),
          callback: function($$v) {
            _vm.$set(obj, "field", $$v)
          },
          expression: "obj.field"
        }
      })], 1), _vm._v(" "), _c('td', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (image.kind != 'count'),
          expression: "image.kind != 'count'"
        }]
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (obj.aggregation),
          expression: "obj.aggregation"
        }],
        staticClass: "form-control",
        attrs: {
          "disabled": image.kind != 'score' && image.kind != 'value' && image.kind != 'freq'
        },
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(obj, "aggregation", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }, function($event) {
            return _vm.renderPreview()
          }]
        }
      }, [_c('option', {
        attrs: {
          "value": "null",
          "disabled": "",
          "hidden": ""
        }
      }, [_vm._v("Select Aggregation")]), _vm._v(" "), _vm._l((_vm.AggregationChoices), function(choice) {
        return (image.kind == 'score' || image.kind == 'value') ? _c('option', {
          domProps: {
            "value": choice.id
          }
        }, [_vm._v(_vm._s(choice.text))]) : _vm._e()
      }), _vm._v(" "), _vm._l((_vm.AggFreqChoices), function(choice) {
        return (image.kind == 'freq') ? _c('option', {
          domProps: {
            "value": choice.id
          }
        }, [_vm._v(_vm._s(choice.text))]) : _vm._e()
      })], 2)]), _vm._v(" "), _c('td', [_c('button', {
        staticClass: "btn btn-link pull-right",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.removeSerieFromImage(imageIndex, index)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-close"
      })])])]), _vm._v(" "), _c('tr', [_c('td', {
        attrs: {
          "colspan": "5"
        }
      }, [_c('boolean-expression-widget', {
        attrs: {
          "expression": obj.filter_rule
        },
        on: {
          "updateExpression": function($event) {
            return _vm.updateSerieFilterRule($event, obj)
          }
        }
      })], 1)])])
    })], 2)])])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('FormulateInput', {
    attrs: {
      "type": "button",
      "label": "Add"
    },
    on: {
      "click": _vm.addImage
    }
  })], 1)], 1)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "half"
  }, [_c('h3', [_vm._v("Preview")]), _vm._v(" "), _c('div', {
    staticClass: "preview-canvas",
    class: {
      'metric-banner': _vm.componentModel.chart == 'MB'
    }
  }, [_c('viz-widget', {
    attrs: {
      "renderData": _vm.renderData,
      "height": 5,
      "chartId": _vm.previewTarget
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bc32b3b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/ComponentModal.vue
// module id = 616
// module chunks = 0